import Vue from 'vue'
// 只能输入正整数  0-9的数字
Vue.directive('enterIntNumber', {
  inserted: function (el) {
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }
    el.addEventListener('keyup', function (e) {
      const input = e.target
      const reg = new RegExp('^\\d{1}\\d*$') // 正则验证是否是数字
      const correctReg = new RegExp('\\d{1}\\d*') // 正则获取是数字的部分
      const matchRes = input.value.match(reg)
      if (matchRes === null) {
        // 若不是纯数字 把纯数字部分用正则获取出来替换掉
        const correctMatchRes = input.value.match(correctReg)
        if (correctMatchRes) {
          input.value = correctMatchRes[0]
        } else {
          input.value = ''
        }
      }
      trigger(input, 'input')
    })
  }
})

// 只能输入一位小数
Vue.directive('enterNumberPoint1', {
  inserted: function (el) {
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }

    el.addEventListener('keyup', function (e) {
      const input = e.target
      const reg = new RegExp('^((?:(?:[1-9]{1}\\d*)|(?:[0]{1}))(?:\\.(?:\\d){0,1})?)(?:\\d*)?$') // 正则验证是否是数字(小数整数均可)
      const matchRes = input.value.match(reg)
      if (matchRes === null) {
        input.value = ''
      } else {
        // matchRes[0]是匹配的无限位的小数
        // matchRes[1]是小数点后两位前面符合的数值
        // 如输入12.223 matchRes[0]是12.223 matchRes[1]12.22 此时input值改为matchRes[1]的值即可
        if (matchRes[1] !== matchRes[0]) {
          input.value = matchRes[1]
        }
      }
      trigger(input, 'input')
    })
  }
})

// 只能输入两位小数
Vue.directive('enterNumberPoint2', {
  inserted: function (el) {
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }

    el.addEventListener('keyup', function (e) {
      const input = e.target
      const reg = new RegExp('^((?:(?:[1-9]{1}\\d*)|(?:[0]{1}))(?:\\.(?:\\d){0,2})?)(?:\\d*)?$') // 正则验证是否是数字(小数整数均可)
      const matchRes = input.value.match(reg)
      if (matchRes === null) {
        input.value = ''
      } else {
        // matchRes[0]是匹配的无限位的小数
        // matchRes[1]是小数点后两位前面符合的数值
        // 如输入12.223 matchRes[0]是12.223 matchRes[1]12.22 此时input值改为matchRes[1]的值即可
        if (matchRes[1] !== matchRes[0]) {
          input.value = matchRes[1]
        }
      }
      trigger(input, 'input')
    })
  }
})

// 输入数字限制最大值
Vue.directive('enterNumberMax', {
  inserted: function (el, binding) {
    // binding.value
    const trigger = (el, type) => {
      const e = document.createEvent('HTMLEvents')
      e.initEvent(type, true, true)
      el.dispatchEvent(e)
    }

    el.addEventListener('keyup', function (e) {
      const input = e.target
      const value = input.value
      if (parseFloat(value) > parseFloat(binding.value)) {
        input.value = binding.value
      }
      trigger(input, 'input')
    })
  }
})
